import _cloneDeep from 'lodash/cloneDeep';

export default {
  clientResults: (state) => _cloneDeep(state.clientResults),
};
